module.exports = __webpack_public_path__ + "static/media/correct.3c691083.wav";